import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { provideRouter } from '@angular/router';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { provideToastr } from 'ngx-toastr';
import { appRoutes } from '~/app.routes';
import { APP_STORAGE } from '~/app.storage';
import { authenticationInterceptor } from '~/interceptors/authentication.interceptor';
import { httpResponseInterceptor } from '~/interceptors/http-response.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([httpResponseInterceptor, authenticationInterceptor])),
    provideToastr({ preventDuplicates: true, tapToDismiss: true, timeOut: 3000 }),
    provideNativeDateAdapter(),
    provideEnvironmentNgxMask(),
    { provide: APP_STORAGE, useValue: window.localStorage },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { hideRequiredMarker: true } },
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { showDelay: 500 } },
  ],
};
